const columnsAppInPlatformGroup = [
  {
    key: "no",
    title: "#",
    scopedSlots: { customRender: "no" },
    width: 70,
  },

  {
    key: "numberOrder",
    title: "Number Order",
    dataIndex: "numberOrder",
    scopedSlots: { customRender: "price" },
  },
  {
    key: "Name",
    title: "Name",
    dataIndex: "name",
  },
  {
    key: "description",
    title: "Description",
    dataIndex: "description",
  },
  {
    title: "Created at",
    key: "createdAt",
    dataIndex: "createdAt",
    scopedSlots: { customRender: "createdAt" },
  },
  {
    title: "Updated at",
    key: "updatedAt",
    dataIndex: "updatedAt",
    scopedSlots: { customRender: "updatedAt" },
  },
  {
    title: "",
    key: "action",
    scopedSlots: { customRender: "action" },
    fixed: "right",
  },
];

export { columnsAppInPlatformGroup };
